/*
 * Public API Surface of ngx-lib/core/customizatin
 */
export * from './customization.model';
export * from './customization.service';
